/* Collection-scoped search: append the collection's scope word to the
   query on submit (terms are ANDed by Shopify search), unless the
   shopper already typed it. */
(function () {
  'use strict';

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('sa-colsearch')) return;
    var input = form.querySelector('[name="q"]');
    var scope = form.getAttribute('data-scope') || '';
    if (!input || !scope) return;
    var value = input.value.trim();
    if (!value) {
      event.preventDefault();
      input.focus();
      return;
    }
    if (value.toLowerCase().indexOf(scope.toLowerCase()) === -1) {
      input.value = value + ' ' + scope;
    }
  });
})();
